// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_ex-0";
export var fileCarousel = "_ex-2";
export var removeFileButton = "_ex-1";